module.exports = __webpack_public_path__ + "static/media/muji outcome1.fc9ba950.png";